<template>
    <div :class="containerClass">
        <h1>Admin</h1>
        <ul class="nav nav-tabs justify-content-center mb-4" role="tablist">
            <li class="nav-item ms-auto" role="presentation">
                <button id="companies-tab"
                        class="nav-link active"
                        data-bs-toggle="tab"
                        data-bs-target="#companies"
                        role="tab"
                        aria-controls="companies"
                        aria-selected="true"
                        ref="companiesTab">
                    Companies
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button id="users-tab"
                        class="nav-link"
                        data-bs-toggle="tab"
                        data-bs-target="#users"
                        role="tab"
                        aria-controls="users"
                        aria-selected="false"
                        ref="usersTab">
                    Users
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button id="callConfigs-tab"
                        class="nav-link"
                        data-bs-toggle="tab"
                        data-bs-target="#callConfigs"
                        role="tab"
                        aria-controls="callConfigs"
                        aria-selected="false"
                        ref="callConfigsTab">
                    Locations
                </button>
            </li>
            <li class="ms-auto">
                <button class="btn border-0 text-primary"
                        :title="maximized ? 'Minimize' : 'Maximize'"
                        @click="maximized = !maximized">
                    <i v-if="maximized" class="fa fa-minimize"></i>
                    <i v-if="!maximized" class="fa fa-maximize"></i>
                </button>
            </li>
        </ul>
        <div class="tab-content mb-4">
            <div id="companies" class="tab-pane active" role="tabpanel" aria-labelledby="companies-tab">
                <data-grid ref="companiesDataGrid"
                           :dataendpoint="Company.endpoint"
                           :show-advanced="false"
                           :columns="Company.columns"
                           descriptor="name"
                           defaultsort="name"
                           :tool-add="true"
                           :tool-delete="false"
                           :customTools="Company.tools"
                           title="Company"
                           @onselected="onCompanySelected">
                </data-grid>

                <!-- Company-specific stuff -->
                <ul v-if="selectedCompany" class="nav nav-tabs justify-content-start mb-4 small" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button id="company-callConfigs-tab"
                                class="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#company-callConfigs"
                                role="tab"
                                aria-controls="company-callConfigs"
                                aria-selected="false">
                            Locations
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button id="company-users-tab"
                                class="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#company-users"
                                role="tab"
                                aria-controls="company-users"
                                aria-selected="false"
                                @click="tabSwitch">
                            Users
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button id="company-imports-tab"
                                class="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#company-imports"
                                role="tab"
                                aria-controls="company-imports"
                                aria-selected="false"
                                @click="tabSwitch">
                            Imports
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button id="company-skills-tab"
                                class="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#company-skills"
                                role="tab"
                                aria-controls="company-skills"
                                aria-selected="false"
                                @click="tabSwitch">
                            Skills
                        </button>
                    </li>
                </ul>
                <!-- Company-specific stuff -->
                <div v-if="selectedCompany" class="tab-content">
                    <div id="company-imports" class="tab-pane" role="tabpanel" aria-labelledby="company-imports-tab">
                        <data-grid :dataendpoint="Import.endpoint"
                                   :show-advanced="false"
                                   :columns="Import.columns"
                                   :selectable="false"
                                   modal-size="modal-lg"
                                   :tool-add="true"
                                   :tool-delete="true"
                                   title="Import"
                                   :filter="{ companyId: selectedCompany?.id }"></data-grid>
                    </div>
                    <div id="company-skills" class="tab-pane" role="tabpanel" aria-labelledby="company-skills-tab">
                        <data-grid :dataendpoint="Skill.endpoint"
                                   :show-advanced="false"
                                   :columns="Skill.columns"
                                   :selectable="false"
                                   descriptor="name"
                                   defaultsort="name"
                                   defaultsortDir="asc"
                                   modal-size="modal-lg"
                                   :tool-add="true"
                                   :tool-delete="true"
                                   title="Skill"
                                   :filter="{ companyId: selectedCompany?.id }"></data-grid>
                    </div>
                    <div id="company-users" class="tab-pane" role="tabpanel" aria-labelledby="company-users-tab">
                        <data-grid :dataendpoint="AppUser.endpoint"
                                   :show-advanced="false"
                                   :columns="companyUserColumns(AppUser.columns)"
                                   :selectable="false"
                                   descriptor="userName"
                                   defaultsort="userName"
                                   defaultsortDir="desc"
                                   :tool-add="true"
                                   :tool-delete="true"
                                   @url="companyUserUrl"
                                   :customTools="AppUser.tools"
                                   title="User"
                                   :filter="{ companyId: selectedCompany?.id }"></data-grid>
                    </div>
                    <div id="company-callConfigs" class="tab-pane" role="tabpanel" aria-labelledby="company-callConfigs-tab">
                        <data-grid ref="companyCallConfigsDataGrid"
                                   :dataendpoint="CallConfig.endpoint"
                                   :show-advanced="false"
                                   :columns="CallConfig.columns"
                                   :custom-tools="CallConfig.tools"
                                   descriptor="locationNameShort"
                                   modal-size="modal-xl"
                                   :modal-cols="2"
                                   title="Location"
                                   defaultsort="number"
                                   :filter="{ companyId: selectedCompany?.id }"
                                   @onselected="onCallConfigSelected"></data-grid>
                    </div>
                </div>
            </div>
            <!-- Non-company-specific stuff -->
            <div id="users" class="tab-pane" role="tabpanel" aria-labelledby="users-tab">
                <data-grid :dataendpoint="AppUser.endpoint"
                           :show-advanced="false"
                           :columns="AppUser.columns"
                           :selectable="false"
                           descriptor="userName"
                           defaultsort="userName"
                           defaultsortDir="desc"
                           :tool-add="true"
                           :tool-delete="true"
                           :customTools="AppUser.tools"
                           title="User"></data-grid>
            </div>
            <div id="callConfigs" class="tab-pane" role="tabpanel" aria-labelledby="callConfigs-tab">
                <data-grid ref="callConfigsDataGrid"
                           :dataendpoint="CallConfig.endpoint"
                           :show-advanced="false"
                           :columns="CallConfig.columns"
                           :custom-tools="CallConfig.tools"
                           descriptor="locationNameShort"
                           modal-size="modal-xl"
                           :modal-cols="2"
                           title="Location"
                           defaultsort="number"
                           @onselected="onCallConfigSelected"></data-grid>
            </div>
        </div>

        <!-- shared stuff -->
        <ul v-if="selectedCallConfig?.id" class="nav nav-tabs justify-content-start mb-4 small" role="tablist">
            <li v-if="selectedCallConfig?.featureGroupChat" class="nav-item" role="presentation">
                <button id="groupMembers-tab"
                        class="nav-link"
                        data-bs-toggle="tab"
                        data-bs-target="#groupMembers"
                        role="tab"
                        aria-controls="groupMembers"
                        aria-selected="false">
                    Group Members
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button id="callLogs-tab"
                        class="nav-link active"
                        data-bs-toggle="tab"
                        data-bs-target="#callLogs"
                        role="tab"
                        aria-controls="callLogs"
                        aria-selected="true">
                    Call Logs
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button id="trainingData-tab"
                        class="nav-link"
                        data-bs-toggle="tab"
                        data-bs-target="#trainingData"
                        role="tab"
                        aria-controls="trainingData"
                        aria-selected="false">
                    Training Data
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button id="callconfig-skills-tab"
                        class="nav-link"
                        data-bs-toggle="tab"
                        data-bs-target="#callconfig-skills"
                        role="tab"
                        aria-controls="callconfig-skills"
                        aria-selected="false">
                    Skills
                </button>
            </li>
        </ul>

        <div v-if="selectedCallConfig?.id" class="tab-content">
            <div id="callconfig-skills" class="tab-pane" role="tabpanel" aria-labelledby="callconfig-skills-tab">
                <data-grid ref="callConfigSkillsDataGrid"
                           :dataendpoint="Skill.endpoint"
                           :show-advanced="false"
                           :columns="Skill.columns"
                           :selectable="false"
                           descriptor="name"
                           defaultsort="name"
                           defaultsortDir="asc"
                           modal-size="modal-lg"
                           :tool-add="true"
                           :tool-delete="true"
                           :customTools="Skill.tools"
                           title="Skill"
                           :filter="{ callConfigId: selectedCallConfigId }"></data-grid>
            </div>
            <div id="callLogs" class="tab-pane active" role="tabpanel" aria-labelledby="callLogs-tab">
                <data-grid :dataendpoint="CallLog.endpoint"
                           descriptor="callSid"
                           :show-advanced="false"
                           :columns="CallLog.columns"
                           :filter="{ callConfigId: selectedCallConfigId }"
                           :tool-add="false"
                           :tool-delete="false"
                           :tool-edit="false"
                           title="Call Log"
                           defaultsort="createdAt"
                           defaultsortDir="desc"
                           @onselected="onCallLogSelected"></data-grid>
                <div v-if="selectedCallLogId" class="chat">
                    <div v-for="(m, index) in messages" :class="'row ' + (m.inbound ? 'inbound' : 'outbound') + (m.ai ? ' ai' : '')" :key="m.id">
                        <div class="col-sm-2 my-1 small text-end text-muted text-nowrap">
                            <a v-if="m.inbound && isPhone(m.text)" href="" @click.prevent="sendCallbackNotification(m)" class="me-1" title="Callback notification"><i class="fa fa-phone"></i></a>
                            {{ Formatters.localTimeSeconds(m.updatedAt) }}
                        </div>
                        <div class="col-sm-10">
                            <div :class="'my-1 ' + (m.state == 6 ? 'text-center' : 'message')">
                                <p v-if="m.error">&#x26a0;&#xfe0f; {{ m.error }}</p>
                                <span v-html="m.translation || m.text"></span>
                                <div v-if="m.translation" class="translation" v-html="m.text"></div>
                                <div v-if="m.promptTokens" class="tokens"><span class="translation" title="Prompt Tokens, Completion Tokens">{{ m.promptTokens +', '+ m.completionTokens }}</span></div>
                                <a v-if="m.ai" href="" class="btn btn-link" @click.prevent="retrain(m, messages[index-1])"><i class="fa fa-robot text-primary"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="groupMembers" class="tab-pane" role="tabpanel" aria-labelledby="groupMembers-tab">
                <data-grid v-if="selectedCallConfig?.featureGroupChat"
                           :dataendpoint="GroupMember.endpoint"
                           descriptor="name"
                           :show-advanced="false"
                           :show-import="true"
                           :show-export="true"
                           title="Group Member"
                           :pagingcontrols="false"
                           :columns="GroupMember.columns"
                           :filter="{ callConfigId: selectedCallConfigId }"></data-grid>
            </div>
            <div id="trainingData" class="tab-pane" role="tabpanel" aria-labelledby="trainingData-tab">
                <data-grid ref="trainingDataGrid"
                           :dataendpoint="TrainingData.endpoint"
                           :show-advanced="false"
                           :show-import="true"
                           :show-export="true"
                           modal-size="modal-lg"
                           title="Training Data"
                           :pagingcontrols="false"
                           :columns="TrainingData.columns"
                           :custom-tools="TrainingData.tools"
                           :filter="{ callConfigId: selectedCallConfigId }"></data-grid>
            </div>
        </div>
        <!-- Modals -->

        <common-dialog ref="commonDialog"></common-dialog>

        <common-dialog ref="pickSkillDialog" title="Add Company Skill">
            <template #body>
                <h6>Select a skill to add</h6>
                <div v-if="skills.length" class="list-group">
                    <a v-for="skill in skills" :key="skill.id"
                       class="list-group-item list-group-item-action"
                       href="" @click.prevent="selectSkill(skill)">
                        {{ skill.name }}
                    </a>
                </div>
                <div v-else class="alert alert-info">No available skills to add to this location</div>
            </template>
        </common-dialog>
    </div>
</template>
<script>
    import { markRaw } from 'vue';
    import axios from 'axios';
    import CommonDialog from '../components/Dialog/CommonDialog';
    import DataGrid from '../components/DataGrid/DataGrid';
    import { Formatters } from '../common/formatters';
    import { PickList } from '../components/DataGrid/AutoForm';
    import ProvisionPhoneNumbers from '../components/ProvisionPhoneNumbers';

    const callStates = [
        'AnythingElse',
        'QuestionCallback',
        'QuestionName',
        'QuestionPhone',
        'QuestionPhoneConfirm',
        'QuestionSchedule',
        'CallEnded',
        'QuestionScheduleMaintenance',
        'QuestionScheduleTime',
        'ConfirmScheduleTime',
    ];
    const datetime = 'datetime';
    const inGrid = ['grid'];
    let lastSelectedCallConfigId = '';

    export default {
        components: {
            CommonDialog,
            DataGrid,
        },
        data: function () {
            const vm = this;
            return {
                companyRolesList: [{ label: 'Owner', value: 'Owner' }, { label: 'Company Admin', value: 'CompanyAdmin' }, { label: 'Billing Admin', value: 'BillingAdmin' }],
                editingRoles: {},
                Formatters,
                loading: false,
                maximized: false,
                messages: [],
                selectedCallConfig: null,
                selectedCallLogId: null,
                selectedCompany: null,
                skills: [],
            };
        },
        computed: {
            containerClass() {
                return this.maximized ? 'mx-2' : 'container-lg';
            },
            selectedCallConfigId() {
                lastSelectedCallConfigId = this.selectedCallConfig?.id ?? lastSelectedCallConfigId;
                return lastSelectedCallConfigId;
            },
            AppUser() {
                const vm = this;
                return {
                    endpoint: '/users',
                    columns: [
                        {
                            name: 'userName',
                            label: 'Username',
                        }, {
                            name: 'firstName',
                            label: 'First name',
                        }, {
                            name: 'lastName',
                            label: 'Last name',
                        }, {
                            name: 'primaryEmail',
                            label: 'Primary Email',
                        }, {
                            name: 'cellPhone',
                            label: 'Mobile phone',
                        }, {
                            name: 'createdAt',
                            label: 'Created',
                            type: datetime,
                            formatter: Formatters.localDate,
                            editable: false,
                        }, {
                            name: 'updatedBy',
                            label: 'Updated By',
                            editable: false,
                            hidden: inGrid,
                        }, {
                            name: 'updatedAt',
                            label: 'Updated',
                            type: datetime,
                            formatter: Formatters.localDate,
                            editable: false,
                            hidden: inGrid,
                        }, {
                            name: 'password',
                            label: 'Password',
                            type: 'password',
                            hidden: inGrid,
                        }, {
                            name: 'companies',
                            label: 'Companies',
                            type: 'multiselect',
                            service: '/Companies',
                            sortable: false,
                            formatter: function (value) { return value?.length ? value.map(c => c.name).join(', ') : '' },
                        }, {
                            name: 'roles',
                            label: 'Roles',
                            type: 'multiselect',
                            options: [{ label: 'Admin', value: 'Admin' }, { label: 'Customer Admin', value: 'CustomerAdmin' }],
                            sortable: false,
                            strings: true, //just use the string values, not the objects
                            showOnFocus: true,
                            formatter: Formatters.stringArrayFormatter,
                        }
                    ],
                    tools: [{
                        id: 'impersonate',
                        classes: 'btn-outline-secondary text-warning',
                        attr: { title: 'Impersonate' },
                        html: '<i class="fa fa-user-secret"></i>',
                        on: 'row',
                        click: (row) => {
                            vm.$refs.commonDialog.show({
                                title: 'Impersonate User',
                                body: `Are you sure you want to impersonate <b>${row.userName}</b>?`
                            })
                                .on('ok', () => {
                                    window.open(`/admin/impersonate/${row.id}`);
                                });
                        }
                    }]
                }
            },
            CallConfig() {
                const vm = this;
                return {
                    endpoint: '/callconfigs',
                    columns: [
                        {
                            name: 'id',
                            label: 'ID',
                            editable: false,
                            hidden: inGrid,
                        }, {
                            name: 'numbers',
                            label: 'Phone Numbers',
                            headerstyle: { 'min-width': '9em' },
                            type: markRaw(ProvisionPhoneNumbers),
                            sortable: false,
                            renderer(value) {
                                return [...value].map(p => p.number + ' (' + p.language + ')')
                                    .join('<br>');
                            }
                        }, {
                            name: 'locationName',
                            label: 'Location Name',
                            hidden: inGrid,
                        }, {
                            name: 'locationNameShort',
                            label: 'Name (short)',
                            headerstyle: { 'min-width': '10em' },
                            style: { 'max-width': '10em' },
                            innerClass: 'text-truncate',
                        }, {
                            name: 'inboxName',
                            label: 'Inbox Label',
                            headerstyle: { 'min-width': '10em' },
                            style: { 'max-width': '10em' },
                            innerClass: 'text-truncate',
                        }, {
                            name: 'localTimeZone',
                            label: 'Time Zone',
                            type: 'dropdown',
                            style: { 'max-width': '10em' },
                            innerClass: 'text-truncate',
                            required: true,
                            options: PickList.timeZones
                        }, {
                            name: 'enabled',
                            label: 'Enabled',
                            type: 'bool',
                            formatter: Formatters.yesno,
                            headerstyle: { 'min-width': '6em' },
                        }, {
                            name: 'aiName',
                            label: 'AI Name',
                            headerstyle: { 'min-width': '6em' },
                        }, {
                            name: 'aiModel',
                            label: 'Model',
                            type: 'dropdown',
                            options: PickList.aiModels,
                        }, {
                            name: 'customModel',
                            label: 'Custom Model',
                            hidden: inGrid,
                        }, {
                            name: 'announceAI',
                            label: 'Announce as AI',
                            type: 'bool',
                            hidden: inGrid,
                        }, {
                            name: 'introduction',
                            label: 'Introduction',
                            type: 'text',
                            hidden: inGrid,
                        }, {
                            name: 'businessType',
                            label: 'Business Type',
                            hidden: inGrid,
                        }, {
                            name: 'website',
                            label: 'Website',
                            hidden: inGrid,
                        }, {
                            name: 'businessHours',
                            label: 'Business Hours',
                            hidden: inGrid,
                        }, {
                            name: 'callbackTextNumber',
                            label: 'Call Back Text #',
                            hidden: inGrid,
                        }, {
                            name: 'notificationEmail',
                            label: 'Notification Email',
                            type: 'email',
                            hidden: inGrid,
                        }, {
                            name: 'emailNotificationOfChats',
                            label: 'Chat Notifications',
                            type: 'bool',
                            hidden: inGrid,
                        }, {
                            name: 'digestNotifications',
                            label: 'Digest Notifications',
                            type: 'bool',
                            hidden: inGrid,
                        }, {
                            name: 'webChatEnabled',
                            label: 'Web Chat',
                            type: 'bool',
                            formatter: Formatters.yesno,
                            headerstyle: { 'min-width': '6em' },
                        }, {
                            name: 'featureGroupChat',
                            label: 'Group Chat',
                            type: 'bool',
                            formatter: Formatters.yesno,
                            hidden: inGrid,
                        }, {
                            name: 'forwardMessagesToMembers',
                            label: 'Forward messages to members',
                            type: 'bool',
                            formatter: Formatters.yesno,
                            hidden: inGrid,
                            visibleWhen(row) { return row.featureGroupChat; }
                        }, {
                            name: 'answerMode',
                            label: 'Answer Mode',
                            type: 'bool',
                            formatter(value) {
                                return value ? 'User assisted' : 'Automatic';
                            },
                            hidden: inGrid,
                        }, {
                            name: 'sampling',
                            label: 'Sampling',
                            type: 'number',
                            defaultValue: 1,
                            required: true,
                            hidden: inGrid,
                        }, {
                            name: 'contextWindow',
                            label: 'Context Size',
                            type: 'number',
                            defaultValue: 0,
                            required: true,
                            hidden: inGrid,
                        }, {
                            name: 'keys',
                            label: 'Keys',
                            type: 'dictionary',
                            hidden: inGrid,
                        }, {
                            name: 'featureInbox',
                            label: 'Inbox',
                            type: 'bool',
                            hidden: inGrid,
                            formatter: Formatters.yesno,
                        }, {
                            name: 'featureKeywords',
                            label: 'Show Keywords in Web Chat',
                            type: 'bool',
                            hidden: inGrid,
                            formatter: Formatters.yesno,
                        }, {
                            name: 'featureMaintenanceRequests',
                            label: 'Maintenance Requests',
                            type: 'bool',
                            hidden: inGrid,
                            formatter: Formatters.yesno,
                        }, {
                            name: 'featureMemberships',
                            label: 'Memberships',
                            type: 'bool',
                            hidden: inGrid,
                            formatter: Formatters.yesno,
                        }, {
                            name: 'cancelMembershipResponse',
                            label: 'Cancel Membership Response',
                            type: 'text',
                            hidden: inGrid,
                            hiddenWhen(row) { return !row.featureMemberships; },
                        }, {
                            name: 'startMembershipResponse',
                            label: 'Start Membership Response',
                            type: 'text',
                            hidden: inGrid,
                            hiddenWhen(row) { return !row.featureMemberships; },
                        }, {
                            name: 'scheduleTextMessage',
                            label: 'Schedule Text',
                            type: 'text',
                            hidden: inGrid,
                        }, {
                            name: 'salesPitchQuestions',
                            label: 'Sales Pitch Questions',
                            type: 'text',
                            hidden: inGrid,
                        }, {
                            name: 'updatedAt',
                            label: 'Updated',
                            editable: false,
                            hidden: inGrid,
                            type: datetime,
                            formatter: Formatters.localDateTime,
                        }, {
                            name: 'updatedBy',
                            label: 'Updated By',
                            editable: false,
                            hidden: inGrid,
                        }, {
                            name: 'createdAt',
                            label: 'Created',
                            editable: false,
                            type: datetime,
                            formatter: Formatters.localDate,
                        },
                    ],
                    tools: [
                        {
                            id: 'webchat',
                            click: vm.webChat,
                            classes: 'btn btn-outline-secondary',
                            attr: { title: 'Open Web Chat' },
                            html: '<i class="fa fa-comments"></i>',
                            on: 'row',
                            visibleWhen(row) { return row.webChatEnabled && vm.selectedCompany?.webChatEnabled; }
                        }
                    ]
                }
            },
            CallLog() {
                return {
                    endpoint: '/calllogs',
                    columns: [
                        {
                            name: 'callSid',
                            label: 'Call ID',
                            cellClass: 'overflow-hidden',
                            style: { 'max-width': '20em' },
                        }, {
                            name: 'fromPhone',
                            label: 'From',
                        }, {
                            name: 'toPhone',
                            label: 'To',
                            headerstyle: { 'min-width': '3em' },
                        }, {
                            name: 'state',
                            label: 'State',
                            formatter(v) {
                                return callStates[v] ?? 'None';
                            },
                        }, {
                            name: 'createdAt',
                            label: 'Started',
                            type: datetime,
                            formatter: Formatters.localDateTime,
                        }, {
                            name: 'updatedAt',
                            label: 'Ended',
                            type: datetime,
                            formatter: Formatters.localDateTime,
                        }, {
                            name: 'messageCount',
                            label: 'Messages',
                            type: 'number',
                        }, {
                            name: 'guestCardCreated',
                            label: 'Guest Card',
                            renderer(value) {
                                switch (value) {
                                    case 1: return '<i class="fa fa-address-card" title="Created GC"></i>';
                                    case 2: return '<i class="fa fa-comment-sms" title="SMS Sent"></i>';
                                    case 4: return '<i class="fa fa-envelope" title="Email Sent"></i>';
                                    case 6: return '<i class="fa fa-comment-sms" title="SMS Sent"></i> <i class="fa fa-envelope" title="Email Sent"></i>';
                                    default: return '';
                                }
                            },
                        },
                    ]
                }
            },
            Company() {
                return {
                    endpoint: '/companies',
                    columns: [
                        {
                            name: 'name',
                            label: 'Name',
                        }, {
                            name: 'description',
                            label: 'Description',
                        }, {
                            name: 'website',
                            label: 'Website',
                        }, {
                            name: 'webChatEnabled',
                            label: 'Web Chat',
                            type: 'bool',
                            formatter: Formatters.yesno,
                        }, {
                            name: 'featureGroupChat',
                            label: 'Group Chat',
                            type: 'bool',
                            formatter: Formatters.yesno,
                        }, {
                            name: 'keys',
                            label: 'Keys',
                            type: 'dictionary',
                            hidden: inGrid,
                        },
                    ],
                    tools: []
                }
            },
            GroupMember() {
                return {
                    endpoint: '/groupmembers',
                    columns: [
                        {
                            name: 'name',
                            label: 'Name',
                        }, {
                            name: 'phoneNumber',
                            label: 'Phone Number',
                            type: 'tel',
                            required: true
                        }, {
                            name: 'isOwner',
                            label: 'Group Owner',
                            type: 'bool',
                            formatter: Formatters.yesno,
                        }, {
                            name: 'enabled',
                            label: 'Enabled',
                            type: 'bool',
                            defaultValue: true,
                            formatter: Formatters.yesno,
                        },
                    ],
                }
            },
            Import() {
                return {
                    endpoint: '/imports',
                    columns: [
                        {
                            name: 'key',
                            label: 'Key',
                        }, {
                            name: 'importType',
                            label: 'Type',
                            type: 'dropdown',
                            required: true,
                            options: [{ value: 1, text: 'AppFolio' }]
                        }, {
                            name: 'username',
                            label: 'Username',
                        }, {
                            name: 'password',
                            label: 'Password',
                            type: 'password',
                            formatter: Formatters.obfuscated,
                        }, {
                            name: 'url',
                            label: 'URL',
                        }, {
                            name: 'enabled',
                            label: 'Enabled',
                            type: 'bool',
                            formatter: Formatters.yesno,
                        },
                    ],
                }
            },
            Skill() {
                const vm = this;
                return {
                    endpoint: '/skills',
                    columns: [
                        {
                            name: 'name',
                            label: 'Name',
                        }, {
                            name: 'description',
                            label: 'Description',
                            type: 'text',
                        }, {
                            name: 'definition',
                            label: 'Definition',
                            type: 'code',
                            hidden: inGrid,
                        }, {
                            name: 'parameters',
                            label: 'Parameters',
                            type: 'code',
                            hidden: inGrid,
                        }, {
                            name: 'enabled',
                            label: 'Enabled',
                            type: 'bool',
                            headerstyle: { 'min-width': '3em' },
                            formatter: Formatters.yesno,
                        }, {
                            name: 'requiresPhoneNumber',
                            label: 'Require Phone',
                            type: 'bool',
                            hidden: inGrid,
                            formatter: Formatters.yesno,
                        }, {
                            name: 'createdAt',
                            label: 'Created',
                            type: datetime,
                            formatter: Formatters.localDate,
                            editable: false,
                            hidden: inGrid,
                        }, {
                            name: 'updatedAt',
                            label: 'Updated',
                            type: datetime,
                            formatter: Formatters.localDate,
                            editable: false,
                            headerstyle: { 'min-width': '6em' },
                        }, {
                            name: 'updatedBy',
                            label: 'Updated By',
                            editable: false,
                            hidden: inGrid,
                        },
                    ],
                    tools: [{
                        id: 'test',
                        classes: 'btn-outline-secondary text-warning',
                        attr: { title: 'Test' },
                        html: '<i class="fa fa-vial-circle-check"></i>',
                        on: 'row',
                        click: vm.showTestDialog
                    }, {
                        id: 'remove',
                        classes: 'btn-outline-secondary text-warning',
                        attr: { title: 'Remove' },
                        html: '<i class="fa fa-xmark fa-lg"></i>',
                        on: 'row',
                        click: vm.removeSkill,
                    }, {
                        id: 'addfromcompany',
                        classes: 'btn-outline-success dropdown-toggle',
                        attr: { title: 'Add company skill' },
                        html: '',
                        on: 'toolbar',
                        click: vm.selectCompanySkill
                    }]
                }
            },
            TrainingData() {
                const vm = this;
                return {
                    endpoint: '/trainingdata',
                    columns: [
                        {
                            name: 'sequence',
                            label: 'Order',
                            type: 'number',
                            editable: false,
                            classes: 'text-end text-nowrap',
                        }, {
                            name: 'id',
                            label: 'ID',
                            editable: false,
                            hidden: inGrid,
                        }, {
                            name: 'aiInstruction',
                            label: 'AI Instruction',
                            type: 'bool',
                            hidden: inGrid,
                            formatter: Formatters.yesno
                        }, {
                            name: 'keyword',
                            label: 'Keyword',
                            type: 'text',
                            headerstyle: { 'min-width': '6em' },
                            hiddenWhen: (row) => row.aiInstruction,
                        }, {
                            name: 'keywordTrigger',
                            label: 'Keyword Triggers Response',
                            type: 'bool',
                            hidden: inGrid,
                        }, {
                            name: 'prompt',
                            label: 'Prompt',
                            type: 'text',
                            headerstyle: { 'min-width': '6em' },
                            hiddenWhen: (row) => row.aiInstruction,
                        }, {
                            name: 'text',
                            label: 'Text',
                            type: 'text',
                        }, {
                            name: 'attachmentThumbnailUrl',
                            hidden: true,
                        }, {
                            name: 'attachmentUrl',
                            label: 'Attachment',
                            type: 'image',
                            onUploaded(model, response) {
                                model.attachmentThumbnailUrl = response.model.thumbUrl;
                            },
                            hidden: inGrid,
                        }, {
                            name: 'instantAnswer',
                            label: 'Instant answer',
                            headerLabel: 'IA',
                            headerAttr: { title: 'Instant answer' },
                            type: 'bool',
                            headerstyle: { 'min-width': '3em' },
                            formatter: Formatters.yesno,
                            hiddenWhen: (row) => row.aiInstruction,
                        }, {
                            name: 'createdAt',
                            label: 'Created',
                            type: datetime,
                            formatter: Formatters.localDate,
                            editable: false,
                            hidden: inGrid,
                        }, {
                            name: 'updatedAt',
                            label: 'Updated',
                            type: datetime,
                            formatter: Formatters.localDate,
                            editable: false,
                            headerstyle: { 'min-width': '6em' },
                        }, {
                            name: 'updatedBy',
                            label: 'Updated By',
                            editable: false,
                            headerstyle: { 'min-width': '8em' },
                        },
                    ],
                    tools: [
                        { id: 'trainModel', click: vm.trainModel, classes: 'btn-outline-success', attr: { title: 'Train Model', disabled: vm.selectedCallConfig?.training }, html: vm.selectedCallConfig?.training ? '<i class="fa fa-circle-notch fa-spin"></i> Training' : '<i class="fa fa-brain"></i> Train' },
                        { id: 'up', click: vm.trainingDataMove, classes: 'btn-outline-secondary text-primary', attr: { title: 'Move up' }, html: '<i class="fa fa-turn-up"></i>', on: 'row' },
                        { id: 'down', click: vm.trainingDataMove, classes: 'btn-outline-secondary text-primary', attr: { title: 'Move down' }, html: '<i class="fa fa-turn-down"></i>', on: 'row' }
                    ]
                }
            },
        },
        methods: {
            clearCache() {
                axios.post('/CallConfigs/Clear', {});
            },
            clearSelections() {
                this.selectedCallConfig = null;
                this.selectedCallLogId = null;
                this.selectedCompany = null;
            },
            companyUserColumns(columns) {
                let cols = [...columns];
                let index = 0;
                var roles;
                cols.find((c, i) => {
                    if (c.name == 'roles') {
                        index = i;
                        roles = { ...c };
                        return true;
                    }
                });
                roles.name = 'companyRoles';
                roles.options = this.companyRolesList;
                cols.splice(index, 1, roles);
                return cols;
            },
            companyUserUrl(data) {
                if (data.name === 'delete') {
                    let id = data.item.id;
                    let companyId = data.item.companyId;
                    data.url = `${this.AppUser.endpoint}/${id}/${companyId}`;
                }
            },
            dateDiff(d1, d2) {
                //comparing to the minute - 2023-05-11T02:03
                return d1.substring(0, 16) !== d2.substring(0, 16);
            },
            dateFormat(d) {
                return Formatters.localDateTime(d);
            },
            isPhone(text) {
                let m = text?.match(/[0-9]/g);
                return m && (m.length === 10 || m.length === 11);
            },
            onCallConfigSelected(c) {
                this.selectedCallConfig = c;
                this.selectedCallLogId = null;
            },
            onCallLogSelected(c) {
                const vm = this;
                this.selectedCallLogId = c.id;
                if (c.id) {
                    axios.get('/CallLogEntries', { params: { callLogId: c.id } })
                        .then(r => {
                            vm.messages = r.data.rows;
                        });
                }
            },
            onCompanySelected(c) {
                const change = c?.id !== this.selectedCompany?.id;
                this.selectedCompany = c;
                if (change) {
                    this.selectedCallConfig = null;
                    this.selectedCallLogId = null;
                }
            },
            removeSkill(skill) {
                const vm = this;
                let callConfigId = this.selectedCallConfig?.id;
                let id = skill.id;
                vm.$refs.commonDialog.show({
                    title: 'Remove Skill',
                    body: `Are you sure you want to remove this skill from the selected location?`,
                    buttons: [{
                        id: 'cancel',
                        html: 'Cancel',
                        classes: 'btn-default',
                        dismiss: true
                    }, {
                        id: 'ok',
                        html: 'Remove',
                        classes: 'btn-danger',
                        click() {
                            axios.post('/skills/remove/' + callConfigId, { id })
                                .then(r => {
                                    vm.$refs.commonDialog.hide();
                                    vm.$refs.callConfigSkillsDataGrid.getData();
                                });
                        },
                        dismiss: false
                    }]
                });
            },
            retrain(response, prompt) {
                const vm = this;
                vm.$refs.trainingDataGrid.addDialog({
                    prompt: prompt.text,
                    text: response.text,
                });
            },
            runTest(row, context) {
                const vm = this;
                vm.$refs.commonDialog.show({
                    title: 'Execute Test',
                    body: `<h6>${row.name}</h6><h1 class="text-center text-muted"><i class="fa fa-3x fa-circle-radiation fa-spin"></i></h1>`,
                    buttons: [{
                        id: 'cancel',
                        html: 'Cancel',
                        classes: 'btn-default',
                        attr: { disabled: true }
                    }, {
                        id: 'ok',
                        html: 'Run Test',
                        classes: 'btn-primary',
                        attr: { disabled: true }
                    }]
                });
                axios.post('/skills/test', { ...row, context, callConfigId: vm.selectedCallConfig?.id })
                    .then(r => {
                        if (r.data.status == 'success') {
                            vm.$refs.commonDialog.show({
                                title: 'Test Results',
                                body: `<pre>${Formatters.json(r.data.model)}</pre>`,
                                buttons: [{
                                    id: 'ok',
                                    html: 'OK',
                                    classes: 'btn-primary',
                                    dismiss: true
                                }]
                            });
                        } else {
                            vm.showError(r.data.message);
                        }
                    })
                    .catch(e => {
                        vm.showError(e);
                    });
            },
            selectCompanySkill() {
                const vm = this;
                let companyId = this.selectedCompany.id;
                let notCallConfigId = this.selectedCallConfig?.id;
                axios.get('/skills', { params: { companyId, notCallConfigId, size: 100 } })
                    .then(r => {
                        vm.skills = r.data.rows;
                        vm.$refs.pickSkillDialog.show({
                            buttons: [{
                                id: 'cancel',
                                html: 'Close',
                                classes: 'btn-default',
                                dismiss: true
                            }]
                        });
                    });
            },
            selectSkill(skill) {
                const vm = this;
                let callConfigId = this.selectedCallConfig?.id;
                let id = skill.id;
                let companyId = this.selectedCompany.id;
                axios.post('/skills/add/' + callConfigId, { id, companyId })
                    .then(r => {
                        vm.$refs.pickSkillDialog.hide();
                        vm.$refs.callConfigSkillsDataGrid.getData();
                    });
            },
            sendCallbackNotification(message) {
                const vm = this;
                let id = message.id;
                axios.post('/CallLogs/CallbackNotification', { id })
                    .then(r => {
                        vm.showMessage('Notification sent!');
                    })
                    .catch(e => {
                        vm.showError(e);
                    });
            },
            showError(e) {
                this.$refs.commonDialog.show({
                    title: 'Error',
                    body: typeof (e) === 'string' ? e : JSON.stringify(e),
                    buttons: [{
                        id: 'ok',
                        html: 'OK',
                        classes: 'btn-primary',
                        dismiss: true
                    }]
                });
            },
            showMessage(e, title) {
                this.$refs.commonDialog.show({
                    title: title || 'Message',
                    body: typeof (e) === 'string' ? e : JSON.stringify(e),
                    buttons: [{
                        id: 'ok',
                        html: 'OK',
                        classes: 'btn-primary',
                        dismiss: true
                    }]
                });
            },
            showTestDialog(row) {
                const vm = this;
                const testContext = 'test-context';
                let context = { name: '', phone: '' };
                if (localStorage[testContext]) { context = JSON.parse(localStorage[testContext]); }
                vm.$refs.commonDialog.show({
                    title: 'Execute Test',
                    body: `<h6>${row.name}</h6><label>Context Data</label><textarea
                        class="form-control"
                        style="height: 120px;font-family: monospace"
                        name="context">${JSON.stringify(context, null, 2)}</textarea>`,
                    buttons: [{
                        id: 'cancel',
                        html: 'Cancel',
                        classes: 'btn-default',
                        dismiss: true
                    }, {
                        id: 'ok',
                        html: 'Run Test',
                        classes: 'btn-primary',
                        click(dialog) {
                            let json = dialog.$el.querySelector('[name=context]').value;
                            let ctx = JSON.parse(json);
                            localStorage[testContext] = json;
                            vm.runTest(row, ctx);
                        },
                        dismiss: false
                    }]
                });
            },
            tabSwitch() {
                this.selectedCallConfig = null;
            },
            trainingDataMove(row, dir) {
                const vm = this;
                axios.patch(`${vm.TrainingData.endpoint}/${dir}/${row.id}`)
                    .then(r => {
                        if (r.status === 200) {
                            vm.$refs.trainingDataGrid.getData(null, true);
                        }
                    }).catch(err => {
                        console.log(err.response?.data?.message);
                    });
            },
            trainModel() {
                const vm = this;
                let callConfigId = this.selectedCallConfig?.id;

                axios.post('/trainingdata/train/status', { callConfigId })
                    .then(r => {
                        if (r.data.status == 'success') {
                            vm.$refs.commonDialog.show({
                                title: 'Train Model',
                                body: `Are you sure you want to run training for this location?
                                    <div class="mt-3">
                                    <label class="fw-semibold">Use data since:</label>
                                    <input name="sinceDate" type="date" class="form-control"></div>`,
                                buttons: [{
                                    id: 'cancel',
                                    html: 'Cancel',
                                    classes: 'btn-default',
                                    dismiss: true
                                }, {
                                    id: 'ok',
                                    html: 'Yes, continue',
                                    classes: 'btn-primary',
                                    click() {
                                        let sinceDate = vm.$refs.commonDialog.find('[name="sinceDate"]').value;
                                        axios.post('/trainingdata/train/confirm', { callConfigId, sinceDate })
                                            .then(r => {
                                                if (r.data.status == 'success') {
                                                    vm.$refs.commonDialog.show({
                                                        title: 'Train Model',
                                                        body: 'Training is in progress.',
                                                        buttons: [{
                                                            id: 'ok',
                                                            html: 'OK',
                                                            classes: 'btn-primary',
                                                            dismiss: true
                                                        }]
                                                    });
                                                } else {
                                                    vm.showError(r.data.message);
                                                }
                                            })
                                            .catch(e => {
                                                vm.showError(e);
                                            });
                                    },
                                    dismiss: false
                                }]
                            });
                        } else {
                            vm.showError(r.data.message);
                        }
                    })
                    .catch(e => {
                        vm.showError(e);
                    });

            },
            webChat(row) {
                const vm = this;
                function openchat(lang) {
                    let url = '/webchat/embed/' + row.id;
                    if (lang) { url = `${url}?lang=${lang}` }
                    window.open(url, '_blank', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=448,height=692');
                }
                if (row.numbers.length > 1) {
                    let buttons = row.numbers.map(n => {
                        let lang = PickList.languages.find(l => l.value == n.language);
                        return {
                            id: lang.value,
                            html: lang.text,
                            classes: 'btn-outline-primary',
                            click(_, e) {
                                openchat(e.id);
                            },
                            dismiss: true,
                        }
                    });
                    buttons.push({ html: 'Cancel', classes: 'btn-outline-secondary', dismiss: true });
                    vm.$refs.commonDialog.show({
                        title: 'Select Language',
                        body: `Select the language for the web chat`,
                        buttons
                    });
                } else {
                    openchat(row.numbers[0]?.language);
                }
            },
        },
        watch: {
            selectedCallConfig: function (value) {
                if (!value) {
                    this.$refs.callConfigsDataGrid?.selectRow({});
                    this.$refs.companyCallConfigsDataGrid?.selectRow({});
                }
            },
            selectedCompany: function (value) {
                if (!value) {
                    this.$refs.companiesDataGrid?.selectRow({});
                }
            },
        },
        mounted() {
            [this.$refs.companiesTab,
            this.$refs.usersTab,
            this.$refs.callConfigsTab
            ].forEach(e => e.addEventListener('shown.bs.tab', this.clearSelections));
        },
    }
</script>